export const DEFAULT_LESSON_FILTER = {
  owners: [],
  itemTypes: [],
  createdAfter: null,
  createdBefore: null,
  recentlyEdited: false,
  archived: false,
};
